import auth from './messages/en/auth';
import common from './messages/en/common';
import enumMessages from './messages/en/enum';
import errors from './messages/en/errors';
import notifications from './messages/en/notifications';
import patients from './messages/en/patients';
import portal from './messages/en/portal';
import print from './messages/en/print';
import queue from './messages/en/queue';
import settings from './messages/en/settings';
import shell from './messages/en/shell';
import validation from './messages/en/validation';
import adminMessages from './messages/en/admin';
import billingMessages from './messages/en/billing';
import opdMessages from './messages/en/opd';
import pharmacyMessages from './messages/en/pharmacy';
import labMessages from './messages/en/lab';
import radiologyMessages from './messages/en/radiology';
import ipdMessages from './messages/en/ipd';
import serverMessages from './messages/en/server';
export const SOURCE_MESSAGES = {
    common,
    shell,
    auth,
    errors,
    validation,
    enum: enumMessages,
    print,
    notifications,
    settings,
    patients,
    portal,
    queue,
    admin: adminMessages,
    billing: billingMessages,
    opd: opdMessages,
    pharmacy: pharmacyMessages,
    lab: labMessages,
    radiology: radiologyMessages,
    ipd: ipdMessages,
    server: serverMessages,
};
//# sourceMappingURL=source-messages.js.map